// BE
export const BOOKING_ACCOMMODATION_PATHNAME = '/booking/accommodation';
export const BOOKING_CONFIRMATION_PAGE_ID = 'booking-confirmation';
export const BOOKING_ENGINE_PAGE_ID = 'bookingEngine';
export const IFRAME_CALLBACK_PAGE_ID = 'iframe-callback';
export const IFRAME_CALLBACK_URL = '/iframe-callback';
export const SELLER_CALLBACK_URL = '/redirect-seller';
export const OPTION_CONFIRMATION_PAGE_ID = 'option-confirmation';
export const QUICK_SEARCH_SELLER_PAGE_ID = 'quick-search';
export const QUICK_SEARCH_URL = '/quick-search';
// PLE
export const PLE_ACCOUNT = 'ple-homepage';
export const PLE_BOOKINGS = 'ple_future_trips_page';
export const PLE_FUTURE_TRIPS = 'ple_future_trips_page';
export const PLE_DASHBOARD = 'ple_dashboard';
export const PLE_GREAT_MEMBERS_PAGE_ID = 'ple-great-members';
export const PLE_PAYMENT_CONFIRMATION_PAGE_ID = 'ple-payment-confirmation';
export const PLE_BOOKING_STAYS_PAGE_ID = 'ple-trips';
export const PLE_PRE_PAYMENT_PAGE_ID = 'ple-pre-payment';
export const PLE_PRE_PAYMENT_REDIRECTION_PAGE_ID = 'ple-pre-payment-redirection';
export const PLE_PROFILE_PAGE_ID = 'ple-profile';
export const PLE_SEARCHES_PAGE_ID = 'ple-searches';
export const PLE_SPONSORSHIP_PAGE_ID = 'ple-sponsorship';
export const SIGNOUT = 'signout';
// SHOPPING
export const EDITORIAL_ARTICLE_PAGE_ID = 'article';
export const EDITORIAL_THEME_PAGE_ID = 'theme';
export const HOME = 'home';
export const FRAGMENTS_FOOTER_PAGE_ID = 'fragments-footer';
export const NEWSLETTER_CONFIRMATION_PAGE_ID = 'newsletter-confirmation';
export const NEWSLETTER_SUBSCRIPTION_PAGE_ID = 'newsletter-subscription';
export const NEWSLETTER_UNSUBSCRIPTION_PAGE_ID = 'newsletter-unsubscription';
export const PAYMENT_REDIRECT_PAGE_ID = 'payment-redirect';
export const SEARCH_PAGE_ID = 'search';
export const SEARCH_PAGE_URL = '/s';
export const SITEPLAN_PAGE_ID = 'siteplan';
export const SITEPLAN_PAGE_URL = `/${SITEPLAN_PAGE_ID}`;
